import React, { useState, useContext } from 'react';

import UIContext from 'components/Utils/UIContext';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

import { find } from 'lodash';

import { sortFishboneBranches } from 'utils/fishboneSort';

import { sortFishboneNodes } from 'utils/fishboneSort';

import { ConfirmModal } from 'components/Modal/ConfirmModal';

import { FishboneBranch } from './FishboneBranch';
import { FishboneBody } from './FishboneBody';
import { FishboneTail } from './FishboneTail';
import { FishboneHead } from './FishboneHead';
import FishboneBranchEditionModal from 'components/Modal/FishboneBranchEditionModal';
import { FishboneItemGeneralTab } from './Tabs/FishboneItemGeneralTab';
import { FishboneLinkSection } from './Tabs/FishboneLinkSection';
import FishboneItemEditionModal from 'components/Modal/FishboneItemEditionModal';
import FishboneHeadEditionModal from 'components/Modal/FishboneHeadEditionModal';
import { useFishboneController } from 'hooks/useFishboneController';
import { ItemTagsTab } from 'components/tabs/ItemTagsTab';
import { Tag } from 'antd';
import { sortBy, uniq } from 'lodash';

import dayjs from 'dayjs';
import { getItemAlteredByScenario } from 'utils/rules';
import { SideMenu } from 'layout/SideMenu';

import BotTab from 'components/tabs/BotTab';
import DisabledTab from 'components/tabs/DisabledTab';

import { FishboneBranchGeneralTab } from './Tabs/FishboneBranchGeneralTab';
import { FishboneFiltersTab } from './Tabs/FishboneFiltersTab';
import { DisplayTab } from './Tabs/DisplayTab';
import { BranchSortList } from './Tabs/BranchSortList';
import { getUpdatedObject } from 'utils/graphql';
import { ExportTab } from './Tabs/ExportTab';
import CommentsTab from '../Navigator/Tabs/CommentsTab';
import { Layout } from 'antd';

import './Fishbone.sass';

const retrieveItemBranch = (branches, id) => {
	return branches.find(b => b.items.find(i => i.id === id))
}

const getMatchingItems = (items, timeStartFilter, timeEndFilter, iconFilter, searchTerm, completionFilter, responsibleFilter, matches = {}) => {

	if (!items) return {};

	items.forEach(i => {
		if (
			isMatchingTerm(i, searchTerm) &&
			isMatchingTime(i, timeStartFilter, timeEndFilter) &&
			isMatchingIcon(i, iconFilter) &&
			isMatchingCompletion(i, completionFilter) &&
			isMatchingResponsible(i, responsibleFilter)
		) {
			matches[i.id] = true;
		}

		if (i.items) {
			matches = { ...matches, ...getMatchingItems(i.items, timeStartFilter, timeEndFilter, iconFilter, searchTerm, completionFilter, responsibleFilter, matches) }
		}
	})

	return matches;
}

const isMatchingResponsible = (item, responsibleFilter) => {
	if (!responsibleFilter) return true;
	const needle = String(responsibleFilter).trim().toLowerCase();
	if (!needle) return true;
	return !!(item.responsible && String(item.responsible).toLowerCase().includes(needle));
}

const isMatchingTerm = (item, searchTerm) => {
	if (!searchTerm) return true
	return item.name.toLowerCase().includes(searchTerm.toLowerCase())
		|| (item.description && item.description.toLowerCase().includes(searchTerm.toLowerCase()))
		|| (item.responsible && item.responsible.toLowerCase().includes(searchTerm.toLowerCase()))

}

const isMatchingTime = (item, timeStartFilter, timeEndFilter) => {

	if (!timeEndFilter && !timeStartFilter) return true

	if (timeStartFilter) {
		if (item.startOn && timeStartFilter == "undefined") {
			return false
		}
		if (!item.startOn && timeStartFilter && timeStartFilter !== "undefined") {
			return false
		}
		if (item.startOn && timeStartFilter == "past") {
			if (dayjs(item.startOn).isAfter(dayjs())) return false
		}
		if (item.startOn && timeStartFilter == "week") {
			if (dayjs(item.startOn).isAfter(dayjs().add(7, 'days')) || dayjs(item.startOn).isBefore(dayjs())) return false
		}

		if (item.startOn && timeStartFilter == "month") {
			if (dayjs(item.startOn).isAfter(dayjs().add(1, 'month')) || dayjs(item.startOn).isBefore(dayjs())) return false
		}

		if (item.startOn && timeStartFilter == "quarter") {
			if (dayjs(item.startOn).isAfter(dayjs().add(3, 'month')) || dayjs(item.startOn).isBefore(dayjs())) return false
		}

		if (item.startOn && timeStartFilter == "year") {
			if (dayjs(item.startOn).isAfter(dayjs().add(1, 'year')) || dayjs(item.startOn).isBefore(dayjs())) return false
		}
	}

	if (timeEndFilter) {

		if (item.endOn && timeEndFilter == "undefined") {
			return false
		}
		if (!item.endOn && timeEndFilter !== "undefined" && item.completion != 100) {
			return false
		}

		if (item.endOn && timeEndFilter == "overdue") {
			if (dayjs(item.endOn).isAfter(dayjs())) return false
		}


		if (item.endOn && timeEndFilter == "week") {
			if (dayjs(item.endOn).isAfter(dayjs().add(7, 'days')) || dayjs(item.endOn).isBefore(dayjs())) return false
		}

		if (item.endOn && timeEndFilter == "month") {
			if (dayjs(item.endOn).isAfter(dayjs().add(1, 'month')) || dayjs(item.endOn).isBefore(dayjs())) return false
		}

		if (item.endOn && timeEndFilter == "quarter") {
			if (dayjs(item.endOn).isAfter(dayjs().add(3, 'month')) || dayjs(item.endOn).isBefore(dayjs())) return false
		}

		if (item.endOn && timeEndFilter == "year") {
			if (dayjs(item.endOn).isAfter(dayjs().add(1, 'year')) || dayjs(item.endOn).isBefore(dayjs())) return false
		}
	}

	return true
}

const isMatchingIcon = (item, iconFilter) => {

	if (!iconFilter) return true

	if (iconFilter === undefined || iconFilter == null) {
		if (item.icon) return false
	}

	return item.icon == iconFilter || (!item.icon && iconFilter == "faCrosshairs")
}

const isMatchingCompletion = (item, completionFilter) => {

	if (!completionFilter) return true

	console.log('isMatchingCompletion', item.completion, completionFilter)

	if (completionFilter === "not_started") {
		return (!item.completion)
	}

	if (completionFilter === "in_progress") {
		return (item.completion > 0 && item.completion < 100)
	}

	return (item.completion && item.completion == 100)

}

export const Fishbone = (props: any) => {
	const [editedItem, setEditedItem] = React.useState<any | null>(null);
	const [draggingItem, setDraggingItem] = React.useState<any | null>(null);
	const [dragOverBranchId, setDragOverBranchId] = React.useState<string | null>(null);
	// Sous-arête survolée pendant un drag d'item : sert de point d'insertion.
	// `dropTargetSide` indique si l'on insère AVANT ou APRÈS cette sous-arête,
	// selon la position du curseur par rapport à son milieu. null = fin de branche.
	const [dropTargetItemId, setDropTargetItemId] = React.useState<string | null>(null);
	const [dropTargetSide, setDropTargetSide] = React.useState<'before' | 'after'>('before');
	const [dragPos, setDragPos] = React.useState<{ x: number; y: number } | null>(null);
	const [dragCandidate, setDragCandidate] = React.useState<{ item: any; startX: number; startY: number } | null>(null);
	// Drag-and-drop des arêtes (branches) : même mécanisme mouse-event que les items.
	const [draggingBranch, setDraggingBranch] = React.useState<any | null>(null);
	const [dragOverBranchTargetId, setDragOverBranchTargetId] = React.useState<string | null>(null);
	const [branchDragCandidate, setBranchDragCandidate] = React.useState<{ branch: any; startX: number; startY: number } | null>(null);
	const params: any = useParams();

	const {
		createFishboneBranch, updateFishboneBranch, deleteFishboneBranch, moveFishboneBranchToIndex,
		createFishboneItem, updateFishboneItem, deleteFishboneItem, updateFishboneItemBranch, moveFishboneItemToIndex,
		updateBranchTaggings, updateItemTaggings
	} = useFishboneController();

	const fishboneBranchs = (props.fishboneBranchs || [])
		.map(b => {
			const alteredBranch = getItemAlteredByScenario(b, props.scenario);
			// Tri P2 : ordre manuel par `position` (fallback createdAt->id).
			const alteredItems = sortFishboneNodes(
				(b.items || [])
					.map(i => getItemAlteredByScenario(i, props.scenario))
					.filter(i => i.enabled !== false)
			);
			return {
				...alteredBranch,
				items: alteredItems,
				completion: alteredItems.length > 0 ? alteredItems.reduce((acc, i) => acc + (i.completion || 0), 0) / alteredItems.length : 0,
			};
		})
		.filter(b => b.enabled !== false);
	const selectedBranch = props.selection ? [...fishboneBranchs].find(i => i.id == (props.selection.__typename == "FishboneBranch" ? props.selection.id : props.selection.fishboneBranchId)) : null;
	const selection = props.selection && props.selection.__typename == "FishboneBranch" && selectedBranch
		? selectedBranch
		: props.selection && props.selection.__typename == "FishboneItem" && selectedBranch
			? selectedBranch.items?.find(i => i.id == props.selection.id) || null
			: null
	const { risks = [] } = props;

	const { t } = useTranslation();
	const uiContext = useContext(UIContext);
	const canEdit = uiContext.canEdit;

	const [timeStartFilter, setTimeStartFilter] = useState(null);
	const [timeEndFilter, setTimeEndFilter] = useState(null);
	const [iconFilter, setIconFilter] = useState(null);
	const [completionFilter, setCompletionFilter] = useState(null);
	const [responsibleFilter, setResponsibleFilter] = useState<string>("");
	const [tagFilter, setTagFilter] = useState<string[]>([]);

	const allTags = sortBy(props.tags || [], 'name');
	const usedTags = uniq(
		(props.fishboneBranchs || []).flatMap((b: any) => [
			...((b.taggings || []).map((t: any) => t.tagId)),
			...((b.items || []).flatMap((i: any) => (i.taggings || []).map((t: any) => t.tagId)))
		])
	);

	// Tri des arêtes : 'startOn' | 'name' | 'manual'. En 'manual', l'ordre est
	// piloté par la liste triable du side menu (le DnD sur le chart est désactivé).
	// Effet highlight : la branche déplacée au tri clignote brièvement sur le chart.
	const [highlightBranchId, setHighlightBranchId] = React.useState<string | null>(null);
	const highlightTimerRef = React.useRef<any>(null);
	// Réordonne sur l'ENSEMBLE des arêtes (y compris celles masquées dans le
	// scénario, absentes de la liste visible) pour qu'elles ne perdent pas leur
	// place : on insère `draggedId` avant/après `targetId` dans l'ordre complet.
	const handleReorderBranches = async (draggedId: string, targetId: string, after: boolean) => {
		setHighlightBranchId(draggedId);
		if (highlightTimerRef.current) clearTimeout(highlightTimerRef.current);
		highlightTimerRef.current = setTimeout(() => setHighlightBranchId(null), 2300);

		const fullOrdered = sortFishboneNodes(props.fishboneBranchs || []);
		const withoutDragged = fullOrdered.filter((b: any) => b.id !== draggedId);
		let insertIndex = withoutDragged.findIndex((b: any) => b.id === targetId);
		if (insertIndex < 0) return;
		if (after) insertIndex += 1;
		await moveFishboneBranchToIndex(fullOrdered, draggedId, insertIndex);
	};

	const branchSort = props.preferences?.pages?.fishbone?.branchSort || 'startOn';
	const setBranchSort = (value: string) => {
		props.setPreferences('pages', 'fishbone.branchSort', value);
	};

	const isMatchingTag = (item: any) => {
		if (!tagFilter || tagFilter.length === 0) return true;
		return (item.taggings || []).some((t: any) => tagFilter.includes(t.tagId));
	};

	const getMatchingItemsWithTag = (items: any[], matches: Record<string, boolean> = {}) => {
		if (!items) return matches;
		items.forEach(i => {
			if (
				isMatchingTerm(i, props.searchTerm) &&
				isMatchingTime(i, timeStartFilter, timeEndFilter) &&
				isMatchingIcon(i, iconFilter) &&
				isMatchingCompletion(i, completionFilter) &&
				isMatchingResponsible(i, responsibleFilter) &&
				isMatchingTag(i)
			) {
				matches[i.id] = true;
			}
			if (i.items) {
				matches = { ...matches, ...getMatchingItemsWithTag(i.items, matches) };
			}
		});
		return matches;
	};

	const matchingIndexedItems = getMatchingItemsWithTag(fishboneBranchs);

	// Ordre des arêtes : tri manuel par position ou préférence utilisateur.
	// Cet ordre reste STABLE pendant un drag de branche (pas d'aperçu live) :
	// aucune branche ne bouge sous le curseur, donc pas de clignotement. Le
	// réordonnancement n'a lieu qu'au drop (handleDropBranch).
	const realBranchOrder = branchSort === 'manual'
		? sortFishboneNodes(fishboneBranchs || [])
		: sortFishboneBranches(fishboneBranchs || [], branchSort);

	const availableWidth = window.innerWidth - 300 - 80;
	const availableHeight = window.innerHeight * 0.95 - 100 - 20;

	const fishboneTailWidth = 60;
	const fishboneTailHeight = 80;

	const resolveBranches = (id: string) => {
		const inFiltered = fishboneBranchs.find((s: any) => s.id === id);
		return inFiltered ? fishboneBranchs : props.fishboneBranchs;
	};

	const handleCreateBranch = async () => {
		if (!canEdit) return;
		props.pushModal(
			<FishboneBranchEditionModal
				onHide={() => {
					props.popModal();
				}}
				onSave={async (values: any) => {
					const result = await createFishboneBranch(
						params.id,
						values,
						props.scenario,
						props.scenarios || []
					);
					props.popModal();
					props.select(result.data?.createFishboneBranch);
				}}
				id={false}
				values={{
					name: '',
					description: '',
					startOn: null,
					endOn: null,
					evaluatedAt: null,
					responsible: ''
				}}
			></FishboneBranchEditionModal>
		);
	};

	const handleCreateItem = async (fishboneBranchId, event) => {

		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}

		if (!canEdit) return;

		props.pushModal(
			<FishboneItemEditionModal
				onHide={() => {
					props.popModal();
				}}
				onSave={async (values: any) => {
					const result = await createFishboneItem(fishboneBranchId, values, {}, props.scenario, props.scenarios || []);
					props.popModal();
					props.select(result.data?.createFishboneItem);
				}}
				id={false}
				values={{
					name: '',
					weight: 1,
					trend: '',
					description: '',
					responsible: '',
					completion: 0,
					startOn: null,
					endOn: null,
					evaluatedAt: null,
				}}
			></FishboneItemEditionModal>
		);
	};

	const handleCloneItem = async (item: any) => {
		if (!canEdit) return;

		const branch = find(
			fishboneBranchs,
			(b) => b.id === item.fishboneBranchId
		);

		props.pushModal(
			<FishboneItemEditionModal
				onHide={() => {
					props.popModal();
				}}
				onSave={async (values: any) => {
					const result = await createFishboneItem(item.fishboneBranchId, values, {}, props.scenario, props.scenarios || []);
					props.popModal();
					props.select(result.data?.createFishboneItem);
				}}
				id={false}
				minDate={branch?.startOn}
				maxDate={branch?.endOn}
				values={{
					name: (item?.name || '') + ' - Copy',
					weight: item?.weight || 1,
					completion: item?.completion || 0,
					trend: item?.trend || '50',
					responsible: item?.responsible,
					description: item?.description || '',
					startOn: item?.startOn ? dayjs(item?.startOn) : null,
					endOn: item?.endOn ? dayjs(item?.endOn) : null,
					evaluatedAt: item?.evaluatedAt ? dayjs(item?.evaluatedAt) : null,
				}}
			></FishboneItemEditionModal>
		);
	};

	const handleStartDragItem = (item: any, e: MouseEvent | React.MouseEvent) => {
		if (!canEdit) return;
		setDragCandidate({ item, startX: (e as MouseEvent).clientX, startY: (e as MouseEvent).clientY });
	};

	const handleStartDragBranch = (branch: any, e: MouseEvent | React.MouseEvent) => {
		if (!canEdit) return;
		setBranchDragCandidate({ branch, startX: (e as MouseEvent).clientX, startY: (e as MouseEvent).clientY });
	};

	const handleCancelDrag = () => {
		setDraggingItem(null);
		setDragOverBranchId(null);
		setDropTargetItemId(null);
		setDropTargetSide('before');
		document.body.style.userSelect = '';
		setDragCandidate(null);
	};

	const handleCancelBranchDrag = () => {
		setDraggingBranch(null);
		setDragOverBranchTargetId(null);
		document.body.style.userSelect = '';
		setBranchDragCandidate(null);
	};

	// Drop d'un item : réordonnancement au sein de la branche cible (ou simple
	// changement de branche). Le point d'insertion est calculé à partir de la
	// sous-arête survolée (`dropTargetItemId`) et du côté (`dropTargetSide`) :
	// avant ou après son milieu. null = fin de branche.
	const handleDropItemToBranch = async (targetBranchId: string) => {
		if (!draggingItem) return;

		const sameBranch = draggingItem.fishboneBranchId === targetBranchId;
		const targetItemId = dropTargetItemId;
		const targetSide = dropTargetSide;

		// 1. Déplacement inter-branche : on rattache d'abord à la nouvelle branche.
		if (!sameBranch) {
			await updateFishboneItemBranch(draggingItem.id, targetBranchId, draggingItem.fishboneBranchId);
		}

		// 2. Calcul du nouvel ordre dans la branche cible et persistance des positions.
		const targetBranch = fishboneBranchs.find((b: any) => b.id === targetBranchId);
		if (targetBranch) {
			const ordered = sortFishboneNodes(targetBranch.items || []);
			// Pour un déplacement inter-branche, l'item n'est pas encore dans la liste
			// triée locale : on l'ajoute (sa position définitive est recalculée au drop).
			const baseList = sameBranch
				? ordered
				: [...ordered, draggingItem];

			// L'index persisté doit correspondre EXACTEMENT à la position VISIBLE
			// où l'on dépose. moveFishboneItemToIndex retire d'abord l'item drague
			// puis insère à l'index donné DANS la liste restante : on calcule donc
			// la position de la cible APRÈS retrait de l'item drague (comme pour les
			// arêtes), sinon le retrait décale l'index quand l'item drague précède
			// la cible et l'élément atterrit un cran trop loin.
			const withoutDragged = baseList.filter((i: any) => i.id !== draggingItem.id);
			let targetIndex = withoutDragged.length; // défaut : fin de branche
			if (targetItemId && targetItemId !== draggingItem.id) {
				const idx = withoutDragged.findIndex((i: any) => i.id === targetItemId);
				if (idx >= 0) targetIndex = targetSide === 'after' ? idx + 1 : idx;
			}
			await moveFishboneItemToIndex(baseList, draggingItem.id, targetIndex);
		}

		// 3. Ajustement des dates de la branche cible (logique existante inter-branche).
		if (!sameBranch && targetBranch && draggingItem.startOn && draggingItem.endOn) {
			const branchUpdateValues: any = {};
			let needsUpdate = false;

			if (targetBranch.startOn) {
				const branchStartDate = dayjs(targetBranch.startOn);
				const itemStartDate = dayjs(draggingItem.startOn);
				if (itemStartDate.isBefore(branchStartDate)) {
					branchUpdateValues.startOn = draggingItem.startOn;
					needsUpdate = true;
				}
			}

			if (targetBranch.endOn) {
				const branchEndDate = dayjs(targetBranch.endOn);
				const itemEndDate = dayjs(draggingItem.endOn);
				if (itemEndDate.isAfter(branchEndDate)) {
					branchUpdateValues.endOn = draggingItem.endOn;
					needsUpdate = true;
				}
			}

			if (needsUpdate) {
				await handleUpdateBranch(targetBranchId, branchUpdateValues);
			}
		}

		handleCancelDrag();
	};

	// Drop d'une arête (branche) : réordonnancement entre branches. On insère la
	// branche draguée à la place de la branche survolée puis on persiste les
	// positions. Bascule le tri en 'manual' pour que l'ordre soit visible.
	const handleDropBranch = async (targetBranchId: string) => {
		if (!draggingBranch || draggingBranch.id === targetBranchId) {
			handleCancelBranchDrag();
			return;
		}
		// Réordonnancement AU DROP uniquement (la liste rendue n'a pas bougé pendant
		// le drag). moveFishboneBranchToIndex retire d'abord la branche draguée puis
		// insère à l'index donné DANS la liste restante : on calcule donc l'index de
		// la cible APRÈS retrait de la branche draguée. La branche draguée est insérée
		// AVANT la branche cible survolée.
		const ordered = [...realBranchOrder];
		if (ordered.findIndex((b: any) => b.id === targetBranchId) < 0) {
			handleCancelBranchDrag();
			return;
		}
		const withoutDragged = ordered.filter((b: any) => b.id !== draggingBranch.id);
		const insertIndex = withoutDragged.findIndex((b: any) => b.id === targetBranchId);
		if (insertIndex < 0) {
			handleCancelBranchDrag();
			return;
		}
		if (branchSort !== 'manual') setBranchSort('manual');
		await moveFishboneBranchToIndex(ordered, draggingBranch.id, insertIndex);
		handleCancelBranchDrag();
	};

	React.useEffect(() => {
		const handleMouseMove = (e: MouseEvent) => {
			// Démarrage d'un drag d'item au-delà d'un seuil de déplacement.
			if (dragCandidate && !draggingItem) {
				const dx = e.clientX - dragCandidate.startX;
				const dy = e.clientY - dragCandidate.startY;
				if (dx * dx + dy * dy > 36) {
					setDraggingItem(dragCandidate.item);
					setDragPos({ x: 0, y: 0 });
					document.body.style.userSelect = 'none';
				}
			}

			// Démarrage d'un drag de branche au-delà du même seuil.
			if (branchDragCandidate && !draggingBranch) {
				const dx = e.clientX - branchDragCandidate.startX;
				const dy = e.clientY - branchDragCandidate.startY;
				if (dx * dx + dy * dy > 36) {
					setDraggingBranch(branchDragCandidate.branch);
					setDragPos({ x: 0, y: 0 });
					document.body.style.userSelect = 'none';
				}
			}

			if (!draggingItem && !draggingBranch) return;
			const svg = document.querySelector('.Fishbone svg') as SVGSVGElement | null;
			if (!svg) return;
			const pt = svg.createSVGPoint();
			pt.x = e.clientX; pt.y = e.clientY;
			const ctm = svg.getScreenCTM();
			if (!ctm) return;
			const p = pt.matrixTransform(ctm.inverse());
			setDragPos({ x: p.x, y: p.y });
		};
		const handleMouseUp = () => {
			if (draggingItem) {
				handleCancelDrag();
			} else if (draggingBranch) {
				handleCancelBranchDrag();
			} else {
				setDragCandidate(null);
				setBranchDragCandidate(null);
			}
		};
		// Échap : annule le drag en cours et revient à l'ordre réel (aperçu vidé).
		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.key !== 'Escape') return;
			if (draggingItem || dragCandidate) handleCancelDrag();
			if (draggingBranch || branchDragCandidate) handleCancelBranchDrag();
		};
		window.addEventListener('mousemove', handleMouseMove);
		window.addEventListener('mouseup', handleMouseUp, { once: true });
		window.addEventListener('keydown', handleKeyDown);
		return () => {
			window.removeEventListener('mousemove', handleMouseMove);
			window.removeEventListener('keydown', handleKeyDown);
		};
	}, [draggingItem, dragCandidate, draggingBranch, branchDragCandidate]);

	const handleUpdateBranch = async (id: string, values: Object) => {
		if (!canEdit) return;
		await updateFishboneBranch(id, resolveBranches(id), props.scenario, values);
	};

	const handleUpdateItem = async (
		fishboneBranchId: string,
		id: string,
		values: Object
	) => {
		if (!canEdit) return;
		const branch = (props.fishboneBranchs || []).find((s: any) => s.id === fishboneBranchId)
			|| fishboneBranchs.find((s: any) => s.id === fishboneBranchId);

		await updateFishboneItem(id, branch?.items || [], props.scenario, values);

		if (props.selection) props.select(getUpdatedObject(props.selection, props.scenario, values));
	};

	const askDeleteConfirmation = async (
		id: string,
		type: string,
		fishboneBranchId?: string
	) => {
		if (!canEdit) return;
		props.pushModal(
			<ConfirmModal
				title={t('models.' + type + '.messages.delete_confirmation')}
				t={t}
				onConfirm={() => {
					type == 'fishbone_branch'
						? deleteFishboneBranch(id, params.id)
						: deleteFishboneItem(fishboneBranchId, id)

					props.deselect()
				}}
				message={
					t(
						'models.' +
						type +
						'.messages.delete_confirmation_explanation'
					)}
			></ConfirmModal >
		);
	};

	const handleEditHead = () => {
		if (!canEdit) return;
		props.pushModal(
			<FishboneHeadEditionModal
				onHide={() => {
					props.popModal();
				}}
				onSave={(values: Object) => {
					props.onUpdateProject(params.id, { ...props, ...values });
					props.popModal();
				}}
				id={editedItem?.id}
				values={{
					description: props?.description,
					fishboneDescription: props?.fishboneDescription,
					responsible: props?.responsible,
					fishboneStartOn: props?.fishboneStartOn
						? dayjs(props?.fishboneStartOn)
						: null,
					fishboneEndOn: props?.fishboneEndOn
						? dayjs(props?.fishboneEndOn)
						: null
				}}
			></FishboneHeadEditionModal>
		);
	};

	return (
		<Layout className={`Fishbone ${(draggingItem || draggingBranch) ? 'dragging' : ''}`} data-testid="fishbone-page">

			<Layout.Content
				className="pt-1"
				onClick={(e) => {
					if (selection && !(e.target as Element).closest('svg')) props.deselect();
				}}
			>
				<h2 className='mb-2'>{t('pages.fishbone.title')}</h2>
				<div className="Body">

					<svg
						width={availableWidth + 'px'}
						height={availableHeight + 'px'}
						viewBox={'0 0 ' + availableWidth + ' ' + availableHeight}
						style={{ overflow: 'visible' }}

					>
						<defs>
							<linearGradient id="redToGreen">
								<stop offset="0%" stopColor="#E70549" />
								<stop offset="100%" stopColor="#24CCB8" />
							</linearGradient>
						</defs>

						<rect
							x={0}
							y={0}
							width={availableWidth}
							height={availableHeight}
							fill="transparent"
							onClick={() => selection && props.deselect()}
						/>

						<FishboneBody
							leftOffset={fishboneTailWidth}
							width={availableWidth - fishboneTailWidth * 2}
							height={availableHeight}
							onCreateBranch={canEdit ? handleCreateBranch : undefined}
							scenario={props.scenario}
						>
							{realBranchOrder.map((fb, index) => (
								<FishboneBranch
									key={fb.id}
									{...fb}
									branchIndex={index}
									highlight={fb.id === highlightBranchId}
									selected={selection?.id === fb.id}
									selection={selection}
									points={fb.items}
									onCreateItem={canEdit ? (e) => handleCreateItem(fb.id, e) : undefined}
									onUpdateItem={(id, values) =>
										handleUpdateItem(fb.id, id, values)
									}
									onEditBranch={(o) => setEditedItem(o)}
									onUpdateBranch={(id, values) =>
										handleUpdateBranch(id, values)
									}
									onEditItem={setEditedItem}
									onSelectItem={props.select}
									draggingItem={draggingItem}
									draggingBranch={draggingBranch}
									dropTargetItemId={dropTargetItemId}
									dropTargetSide={dropTargetSide}
									scenario={props.scenario}
									dragOver={dragOverBranchId === fb.id || dragOverBranchTargetId === fb.id}
									branchDropTarget={!!draggingBranch && dragOverBranchTargetId === fb.id}
									onBranchEnter={() => {
										// Drag d'item : la branche devient cible de drop (y compris
										// la branche d'origine, pour le réordonnancement interne).
										if (draggingItem) {
											setDragOverBranchId(fb.id);
										}
										// Drag de branche : on survole une autre arête.
										if (draggingBranch && draggingBranch.id !== fb.id) {
											setDragOverBranchTargetId(fb.id);
										}
									}}
									onBranchLeave={() => {
										setDragOverBranchId((prev) => (prev === fb.id ? null : prev));
										setDragOverBranchTargetId((prev) => (prev === fb.id ? null : prev));
										// En quittant entièrement l'arête pendant un drag d'item, on
										// efface le point d'insertion : sinon une cible « fantôme »
										// d'une autre arête resterait surlignée.
										if (draggingItem) {
											setDropTargetItemId((prev) => {
												const inThisBranch = (fb.items || []).some((i: any) => i.id === prev);
												return inThisBranch ? null : prev;
											});
										}
									}}
									onDropOnBranch={() => {
										if (draggingBranch) handleDropBranch(fb.id);
										else handleDropItemToBranch(fb.id);
									}}
									onCancelDrag={handleCancelDrag}
									onStartDragItem={handleStartDragItem}
									onStartDragBranch={(e) => handleStartDragBranch(fb, e)}
									onItemDragEnter={(itemId, side) => {
										// La cible est fonction du SURVOL uniquement (pas de reflow) :
										// on enregistre la sous-arête visée et le côté (avant/après le
										// milieu) déduit de la position du curseur. Mise à jour fine
										// au moindre déplacement, donc on vise bien là où l'on pointe.
										if (draggingItem) {
											setDropTargetItemId(itemId);
											if (side) setDropTargetSide(side);
										}
									}}

									isMatching={matchingIndexedItems[fb.id]}
									matchingIndexedItems={matchingIndexedItems}
								></FishboneBranch>
							))}
						</FishboneBody>
						<g
							transform={
								'translate(0 ' +
								(availableHeight / 2 - fishboneTailHeight / 2) +
								')'
							}
						>
							<FishboneTail
								width={fishboneTailWidth}
								height={fishboneTailHeight}

							></FishboneTail>
						</g>
						<g
							transform={
								'translate(' +
								(availableWidth - fishboneTailWidth) +
								' ' +
								(availableHeight / 2 - (fishboneTailHeight * 0.8) / 2) +
								')'
							}
						>
							<FishboneHead
								branchs={fishboneBranchs}

								{...props}
								width={fishboneTailWidth}
								t={t}
								height={fishboneTailHeight * 0.8}
								onClick={handleEditHead}
							></FishboneHead>
						</g>
						{(draggingItem || draggingBranch) && dragPos && (
							<g className="drag-ghost" transform={`translate(${dragPos.x}, ${dragPos.y})`} style={{ pointerEvents: 'none', opacity: 0.7 }}>
								<circle r={8} fill={'#24CCB8'} stroke={'#0f7b6c'} strokeWidth={1}></circle>
								<text fontSize={12} dx={12} dy={4} fill={'var(--ant-color-text)'}>{(draggingItem || draggingBranch).name}</text>
							</g>
						)}
					</svg>
				</div>
			</Layout.Content>


			<SideMenu defaultTab={!selection ? "filters" : "general"} tabs={(() => {
				const disabledBranches = (props.fishboneBranchs || []).filter(b => getItemAlteredByScenario(b, props.scenario).enabled === false).length;
				const disabledItems = (props.fishboneBranchs || []).flatMap(b => b.items || []).filter(i => getItemAlteredByScenario(i, props.scenario).enabled === false).length;
				const disabledCount = disabledBranches + disabledItems;

				return [
					!selection && {
						id: 'filters',
						title: t('pages.fishbone.tabs.filters.title')
					},
					!selection && {
						id: 'display',
						title: t('pages.fishbone.tabs.display.title')
					},
					selection && {
						id: 'general',
						title: t('pages.fishbone.tabs.general.title')
					},
					selection && {
						id: 'stakeholders',
						title: t('models.item.name_plural')
					},
					selection && {
						id: 'tags',
						title: t('pages.navigator.tabs.tags.title')
					},
					selection && {
						id: 'comments',
						title: t('pages.risks.tabs.comments.title')
					},
					!selection && {
						id: 'deactivated',
						title: `${t('pages.navigator.tabs.disabled.title')}${disabledCount > 0 ? ` (${disabledCount})` : ''}`
					},
					!selection && {
						id: 'bot',
						title: t('pages.fishbone.tabs.bot.title')
					},
					!selection && {
						id: 'export',
						title: t('pages.fishbone.tabs.export.title')
					}
				];
			})()}>
				{function (selectedTab: string, setSelectedTab: (t: string) => void) {

					if (selectedTab == "tags" && selection) return <ItemTagsTab
						allTags={allTags}
						item={selection}
						onClose={() => props.deselect()}
						onUpdateTags={async (item, tagIds) => {
							if (item.__typename === 'FishboneBranch') {
								await updateBranchTaggings(item, tagIds, item.projectId || params.id);
							} else {
								await updateItemTaggings(item, tagIds, params.id);
							}
							const kept = (item.taggings || []).filter((t: any) => tagIds.includes(t.tagId));
							const added = tagIds.filter((id: string) => !(item.taggings || []).find((t: any) => t.tagId === id)).map((id: string) => ({ tagId: id, objectId: item.id }));
							props.select({ ...item, taggings: [...kept, ...added] });
						}}
						onCreateTag={props.onCreateTag}
						areTagsVisible={props.preferences?.pages?.navigator?.tags ?? true}
						setPreferences={props.setPreferences}
						scenario={props.scenario}
					/>;

					if (selectedTab == "general" && selection?.__typename == "FishboneBranch") return <>
						<FishboneBranchGeneralTab
							onAddItem={canEdit ? (e) => handleCreateItem(selection.id, e) : undefined}
							onClose={() => props.deselect()}
							onEdit={canEdit ? () => setEditedItem(selection) : undefined}
							onDisable={canEdit ? async () => {
								await handleUpdateBranch(selection?.id, { enabled: false });
								props.deselect();
							} : undefined}
							onDelete={canEdit ? (id) => askDeleteConfirmation(id, 'fishbone_branch') : undefined}
							selection={selection}
							fishboneBranchs={fishboneBranchs}
							risks={risks}
							stakes={props.stakes}
							indicators={props.indicators}
							stakeholders={props.stakeholders}
							select={props.select}
							scenario={props.scenario}
							onChange={(id, values) => handleUpdateBranch(id, values)}
						/>
						<div className="px-1 mt-1" onClick={() => setSelectedTab('tags')} style={{ cursor: 'pointer' }}>
							{(selection?.taggings?.length > 0) ? (
								(selection.taggings as any[]).map((tagging: any) => {
									const tag = allTags.find((t: any) => t.id === tagging.tagId);
									return tag ? <Tag.CheckableTag key={tag.id} checked className="noselection">{tag.name}</Tag.CheckableTag> : null;
								})
							) : (
								<span style={{ color: 'var(--ant-color-text-tertiary)', fontSize: '0.85rem' }}>Tags →</span>
							)}
						</div>
					</>;

					if (selectedTab == "general" && selection?.__typename == "FishboneItem") return <>
						<FishboneItemGeneralTab
							onAddItem={canEdit ? (e) => handleCreateItem(selection.id, e) : undefined}
							onClose={() => props.deselect()}
							onEdit={canEdit ? () => setEditedItem(selection) : undefined}
							onClone={canEdit ? () => handleCloneItem(selection) : undefined}
							onDisable={canEdit ? async () => {
								const branch = retrieveItemBranch(fishboneBranchs, selection?.id)
								if (branch) {
									await handleUpdateItem(branch.id, selection?.id, { enabled: false });
									props.deselect();
								}
							} : undefined}
							onDelete={canEdit ? (id) => {
								const branch = retrieveItemBranch(fishboneBranchs, id)
								if (branch) {
									askDeleteConfirmation(id, 'fishbone_item', branch?.id)
								}
							} : undefined}
							selection={selection}
							fishboneBranchs={fishboneBranchs}
							risks={risks}
							stakes={props.stakes}
							indicators={props.indicators}
							stakeholders={props.stakeholders}
							select={props.select}
							scenario={props.scenario}
							onChange={(id, values) => {
								const branch = retrieveItemBranch(fishboneBranchs, id)
								if (branch) {
									handleUpdateItem(branch.id, id, values)
								}
							}}
						/>
						<div className="px-1 mt-1" onClick={() => setSelectedTab('tags')} style={{ cursor: 'pointer' }}>
							{(selection?.taggings?.length > 0) ? (
								(selection.taggings as any[]).map((tagging: any) => {
									const tag = allTags.find((t: any) => t.id === tagging.tagId);
									return tag ? <Tag.CheckableTag key={tag.id} checked className="noselection">{tag.name}</Tag.CheckableTag> : null;
								})
							) : (
								<span style={{ color: 'var(--ant-color-text-tertiary)', fontSize: '0.85rem' }}>Tags →</span>
							)}
						</div>
					</>;

					if (selectedTab == "stakeholders" && (selection?.__typename == "FishboneBranch" || selection?.__typename == "FishboneItem")) return <div className="FishboneLinksTab p-2">
						<div className="w-100 text-left mb-2">
							<div className="title">{selection?.name}</div>
							<small>{selection?.__typename == "FishboneBranch" ? t('models.fishbone_branch.name') : t('models.fishbone_item.name')}</small>
						</div>
						<FishboneLinkSection
							target="stakeholder"
							selection={selection}
							nodeType={selection?.__typename == "FishboneBranch" ? "branch" : "item"}
							items={props.stakeholders || []}
							scenario={props.scenario}
							select={props.select}
							title={t('models.item.name_plural')}
							visible={true}
							showTrend={false}
						/>
					</div>

					if (selectedTab == 'comments') {
						return <CommentsTab
							projectId={params.id}
							key={props.selection.id}
							type={props.selection?.__typename}
							selection={props.selection}
							pushModal={props.pushModal}
							popModal={props.popModal}
							scenario={props.scenario}
						>

						</CommentsTab>
					}

					if (selectedTab == "export") return <ExportTab {...props} />

					if (selectedTab == "deactivated") {
						const allFishboneItems = (props.fishboneBranchs || []).flatMap(b => b.items || []);
						return <DisabledTab
							scenario={props.scenario}
							fishboneBranchs={props.fishboneBranchs}
							fishboneItems={allFishboneItems}
							select={props.select}
							hideItemsOfDisabledBranches={true}
							onEnableItem={async (item) => {
								if (item.__typename === 'FishboneBranch') {
									await handleUpdateBranch(item.id, { enabled: true });
								} else if (item.__typename === 'FishboneItem') {
									await handleUpdateItem(item.fishboneBranchId, item.id, { enabled: true });
								}
							}}
							onDeleteItem={(item) => {
								if (item.__typename === 'FishboneBranch') {
									askDeleteConfirmation(item.id, 'fishbone_branch');
								} else if (item.__typename === 'FishboneItem') {
									askDeleteConfirmation(item.id, 'fishbone_item', item.fishboneBranchId);
								}
							}}
						/>;
					}

					return <div className='noselection'>

						{selectedTab == "filters" && <>
							<FishboneFiltersTab
								searchTerm={props.searchTerm}
								setSearchTerm={props.setSearchTerm}
								timeEndFilter={timeEndFilter}
								setTimeEndFilter={setTimeEndFilter}
								timeStartFilter={timeStartFilter}
								setTimeStartFilter={setTimeStartFilter}
								fishboneBranchs={fishboneBranchs}
								iconFilter={iconFilter}
								setIconFilter={setIconFilter}
								completionFilter={completionFilter}
								setCompletionFilter={setCompletionFilter}
								responsibleFilter={responsibleFilter}
								setResponsibleFilter={setResponsibleFilter}
								tags={allTags}
								tagFilter={tagFilter}
								setTagFilter={setTagFilter}
							></FishboneFiltersTab>
						</>
						}

						{selectedTab == "display" && <>
							<DisplayTab
								branchSort={branchSort}
								setBranchSort={setBranchSort}
							></DisplayTab>
							{/* Tri manuel : liste triable des arêtes (drag vertical à
							    poignées), sous les options d'affichage. Pierre. */}
							{branchSort === 'manual' && (
								<BranchSortList
									branches={realBranchOrder}
									onReorder={handleReorderBranches}
								/>
							)}
						</>
						}

						{selectedTab == "bot" && <>
							<BotTab
								projectId={params.id}
								messages={props.botThread?.messages || []}
								onResetThread={props.resetBotThread}
								onSendMessage={(message, callback) => props.addBotMessage(params.id, props.scenario?.id || null, "stakeholders", message, callback)}
							>

							</BotTab></>}

					</div>
				}}
			</SideMenu >

			{
				editedItem && editedItem.__typename === 'FishboneBranch' && (
					<FishboneBranchEditionModal
						onHide={() => {
							setEditedItem(null);
						}}
						onDelete={() => {
							askDeleteConfirmation(editedItem.id, 'fishbone_branch');
							setEditedItem(null);
						}}
						onSave={(values: Object) => {
							handleUpdateBranch(editedItem.id, values);
							setEditedItem(null);
						}}
						minDate={props.fishboneStartOn}
						maxDate={props.fishboneEndOn}
						id={editedItem?.id}
						values={{
							name: editedItem?.name,
							weight: editedItem?.weight || 1,
							description: editedItem?.description || '',
							responsible: editedItem?.responsible,
							startOn: editedItem?.startOn
								? dayjs(editedItem?.startOn)
								: null,
							endOn: editedItem?.endOn
								? dayjs(editedItem?.endOn)
								: null,
							evaluatedAt: editedItem?.evaluatedAt
								? dayjs(editedItem?.evaluatedAt)
								: null,
						}}
					></FishboneBranchEditionModal>
				)
			}

			{
				editedItem && editedItem.__typename === 'FishboneItem' && (
					<FishboneItemEditionModal
						onHide={() => {
							setEditedItem(null);
						}}
						onDelete={() => {
							askDeleteConfirmation(
								editedItem.id,
								'fishbone_item',
								editedItem.fishboneBranchId
							);
							setEditedItem(null);
						}}
						onSave={function (values: Object) {
							handleUpdateItem(
								editedItem.fishboneBranchId,
								editedItem.id,
								values
							);
							setEditedItem(null);
						}}
						id={editedItem?.id}
						minDate={
							find(
								fishboneBranchs,
								(b) => b.id === editedItem.fishboneBranchId
							)?.startOn
						}
						maxDate={
							find(
								fishboneBranchs,
								(b) => b.id === editedItem.fishboneBranchId
							)?.endOn
						}
						values={{
							name: editedItem?.name,
							weight: editedItem?.weight || 1,
							completion: editedItem?.completion,
							trend: editedItem?.trend,
							responsible: editedItem?.responsible,
							description: editedItem?.description || '',
							startOn: editedItem?.startOn
								? dayjs(editedItem?.startOn)
								: null,
							endOn: editedItem?.endOn
								? dayjs(editedItem?.endOn)
								: null,
							evaluatedAt: editedItem?.evaluatedAt
								? dayjs(editedItem?.evaluatedAt)
								: null,
						}}
					></FishboneItemEditionModal>
				)
			}
		</Layout >
	);
};
